// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__1P6sZ","spin":"Spinner_spin__20ABg","container":"Spinner_container__2iWUg"};